export const OPTIONS = [
  { label: 'Control', value: `0` },
  { label: 'Variant', value: `1` },
  { label: 'VariantV2', value: `2` },
];

export const EXP_FEATURE_FLAG = 'exp.';
